<template>
	<tbody>
		<template v-for="d in data">
			<tr :key="d.id" :class="{ 'cursor-pointer': rowInfo }">
				<template v-for="td in tbody">
					<!-- Default template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'default' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<template v-if="td.name === 'website_status_code'">
							<span v-if="getWebsiteStatusBadge(d[td.name]).label" :class="'badge ' + getWebsiteStatusBadge(d[td.name]).class">
								{{ getWebsiteStatusBadge(d[td.name]).label }}
							</span>
							<span v-else>-</span>
						</template>
						<template v-else-if="!td.name.includes('.')">
							{{ d[td.name] }}
							<span v-if="td.name === 'name' && route === 'clients'" class="ms-2 align-middle">
								<template v-if="d.freshbooks_client_id">
									<img
										src="/img/freshbooks.ico"
										alt="Freshbooks client"
										width="16"
										height="16"
										:title="'Freshbooks Client ID: ' + d.freshbooks_client_id"
									/>
								</template>
								<template v-else>
									<span class="text-danger fb-missing-freshbooks" :title="'Missing Freshbooks ID'">
										<font-awesome-icon :icon="['fas', 'question-circle']" />
									</span>
								</template>
							</span>
							<!-- <span v-if="d.onboarding_id != null && td.name === 'name'" class="ms-2 me-2" style="color:#f54f6c" title="Client has Onboarding">
								<font-awesome-icon :icon="['fas', 'swatchbook']" />
							</span>
							<a
								class="me-2"
								:href="dropboxAppUrl + '/dropbox/' + d.dropbox_id + '/files?email=' + authUser.email + '&sauto=soflogin'"
								target="_blank"
								title="Client has Dropbox"
								v-if="td.name === 'name' && d.dropbox_id !== null"
								style="color:#451952"
								><font-awesome-icon :icon="['fas', 'box-open']"
							/></a>
							<span v-if="d.juniper_id != null && td.name === 'name'" class="me-2" style="color:#26425A;font-size:16px" title="Client has Juniper CMS">
								<font-awesome-icon :icon="['fab', 'html5']" />
							</span> -->
						</template>
						<template v-if="td.name.includes('.')">{{ d[td.name.split('.')[0]][td.name.split('.')[1]] }}</template>
						<template v-if="td.name === 'full_name' && d['salesforce_account_id'] !== null"
							><a
								v-if="d['salesforce_account_id']"
								target="_blank"
								:href="'https://hejdevdoo.lightning.force.com/lightning/r/Account/' + d['salesforce_account_id'] + '/view'"
								class="ms-1"
								><img
									src="https://a.sfdcstatic.com/shared/images/c360-nav/salesforce-with-type-logo.svg"
									width="32"
									:title="'Salesforce ID' + d['salesforce_account_id']"
								/>
							</a>
						</template>
					</td>
					<!-- Percent template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'percent' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<template v-if="!td.name.includes('.')">{{ d[td.name] | percent }} </template>
						<template v-if="td.name.includes('.')">{{ d[td.name.split('.')[0]][td.name.split('.')[1]] | percent }}</template>
					</td>
					<!-- Custom template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'custom' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<div v-html="renderCustom(td, d)"></div>
					</td>
					<!-- Boolean template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'boolean' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<template v-if="d[td.name] === 0"> {{ td.no }}</template>
						<template v-if="d[td.name] === 1"> {{ td.yes }}</template>
					</td>
					<!-- Link template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'link' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<template v-if="!td.name.includes('.')">
							<a v-if="d[td.name]" :href="d[td.name]" target="_blank">{{ td.label }}</a>
						</template>
						<template v-if="td.name.includes('.')">
							<a v-if="d[td.name.split('.')[0]][td.name.split('.')[1]]" :href="d[td.name.split('.')[0]][td.name.split('.')[1]]" target="_blank">{{ td.label }}</a>
						</template>
					</td>
					<!-- Users template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'users' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<template v-if="d[td.name]">
							<template v-for="user in JSON.parse(d[td.name])">
								<span :key="user.id" :title="user.email" class="badge bg-primary p-1 px-2 fs-7 me-1">
									{{ user.name }}
								</span>
							</template>
						</template>
						<template v-else>
							<span class="badge bg-danger p-1 px-2">No selected users</span>
						</template>
					</td>
					<!-- Fingerprints template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'fingerprints' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<template v-if="d[td.name] && d[td.name].trim() !== ''">
							<template v-for="(item, index) in d[td.name].split(',').filter(item => item.trim())">
								<span :key="index" class="badge p-1 px-2 me-1 mb-1" :class="getFingerprintBadgeClass(td.name)" style="font-size: 11px;">
									{{ item.trim() }}
								</span>
							</template>
						</template>
						<template v-else>
							<span class="text-muted small">-</span>
						</template>
					</td>
					<!-- Progress template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'progress' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<div v-if="d[td.name]" style="width:200px" class="d-flex">
							<div
								:title="'Finished:' + JSON.parse(d[td.name]).finished + ' | Skipped: ' + JSON.parse(d[td.name]).skipped"
								class="progress"
								style="height: 25px;width:150px"
							>
								<div
									class="progress-bar progress-bar-striped bg-success fs-6 text-dark"
									role="progressbar"
									:style="'width:' + calculatePercent(JSON.parse(d[td.name])) + '%'"
									:aria-valuenow="calculatePercent(JSON.parse(d[td.name]))"
									aria-valuemin="0"
									aria-valuemax="100"
								>
									{{ calculatePercent(JSON.parse(d[td.name])) }} %
								</div>
							</div>
							<span class="ms-2">{{ JSON.parse(d[td.name]).finished + JSON.parse(d[td.name]).skipped }} / {{ JSON.parse(d[td.name]).total }}</span>
						</div>
						<div v-else>
							Not started yet
						</div>
					</td>
					<!-- Google template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'google' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name">
						<template v-if="!td.name.includes('.')">
							<a v-if="d[td.name]" :href="`https://google.com/search?q=${td.label}+${d[td.name]}`" target="_blank">{{ d[td.name] }}</a>
						</template>
					</td>
					<!-- Google template -->
					<td @click="showInformationModal(route, d.id, rowInfo)" v-if="td.type === 'campaignStatus'" :key="'td-tbody-' + td.name">
						<span v-if="d['status'] == 'preparing'" class="badge bg-info"><font-awesome-icon :icon="['fas', 'hammer']" /> Preparing</span>
						<span v-if="d['status'] == 'sent'" class="badge bg-success">Sent</span>
						<span v-if="d['status'] == 'sending'" class="badge bg-info"><font-awesome-icon :icon="['fas', 'spinner']" class="fa-spin" /> Sending</span>
						<span v-if="d['status'] == 'canceled'" class="badge bg-warning">Canceled</span>
						<span v-if="d['status'] == 'scheduled'" class="badge bg-primary"
							><font-awesome-icon :title="d['scheduled_date']" :icon="['fas', 'clock']" /> Scheduled</span
						>
					</td>
					<!-- Action buttons template -->
					<td v-if="td.type === 'actions' && userColumns.includes(td.name)" :key="'td-tbody-' + td.name" :width="td.width ? td.width : 200">
						<template v-for="(btn, index) in td.buttons">
							<template v-if="btn.type === 'default'">
								<template v-if="btn.label === 'View'">
									<a
										:key="index"
										@click="showInformationModal(route, d.id, true)"
										v-if="authUser.permissions.includes(btn.permission) || btn.permission === ''"
										class="btn btn-sm mx-1"
										:class="btn.class"
									>
										<font-awesome-icon :icon="['fas', 'eye']" />
									</a>
								</template>

								<template v-if="btn.label === 'Edit'">
									<router-link
										v-if="authUser.permissions.includes(btn.permission) || btn.permission === ''"
										:key="index"
										class="btn btn-sm mx-1"
										:class="btn.class"
										:to="'/' + route + '/edit/' + d.id"
									>
										<font-awesome-icon :icon="['fas', 'edit']" />
									</router-link>
								</template>
							</template>
							<template v-if="btn.type === 'delete'">
								<a
									:key="index"
									@click="confirmDelete(d)"
									v-if="authUser.permissions.includes(btn.permission) || btn.permission === ''"
									class="btn btn-sm mx-1"
									:class="btn.class"
								>
									<font-awesome-icon :icon="['fas', 'trash']" />
								</a>
							</template>
							<template v-if="btn.type === 'work'">
								<router-link
									:key="index"
									:to="'/' + route + '/work/' + d.id + '/entry'"
									v-if="
										(authUser.permissions.includes(btn.permission) || btn.permission === '') &&
											d.workers &&
											JSON.parse(d.workers).find(w => w.id === authUser.id)
									"
									class="btn btn-sm mx-1"
									:class="btn.class"
									title="Work data entry"
								>
									👨‍💻
								</router-link>
							</template>
						</template>
					</td>
				</template>
			</tr>
		</template>
	</tbody>
</template>

<script>
import restApi from '../../api/index'
import { handleErrors, formatNumberLocale as formatNumberLocaleUtil } from '../../actions/helpers'
import { HTTP_STATUS, STATUS_CODES } from '@/constants/httpStatus'

export default {
	name: 'LPDataTableTbody',
	props: ['tbody', 'data', 'authUser', 'userColumns', 'model', 'route', 'rowInfo'],
	data() {
		return {
			dropboxAppUrl: process.env.VUE_APP_DROPBOX_URL,
		}
	},
	created() {},
	updated() {},
	methods: {
		showModal(singleData) {
			this.$emit('showModal', singleData)
		},

		showInformationModal(route, id, displayRow) {
			if (displayRow) {
				this.$emit('showInformationModal', { route: route, id: id })
			}
		},

		renderCustom(td, d) {
			let newHtml = td.style
			td.values.forEach(val => {
				if (val.type === 'data') {
					newHtml = newHtml.replace(val.name, d[val.value])
				} else if (val.type === 'class') {
					val.conditions.forEach(cond => {
						if (cond.value == d[val.value]) {
							newHtml = newHtml.replace(val.name, cond.replace)
						}
					})
				} else {
					val.conditions.forEach(cond => {
						if (cond.value == d[val.value]) {
							newHtml = newHtml.replace(val.name, cond.replace)
						}
					})
				}
			})

			return newHtml
		},
		confirmDelete(data) {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						restApi
							.delete(`/${this.route}/` + data.id)
							.then(() => {
								this.$emit('deleted')
								this.$swal.fire({
									icon: 'success',
									title: `${this.model}`.toUpperCase() + ' with id ' + data.id + ' successfully removed!',
								})
							})
							.catch(error => {
								this.$swal.fire({
									icon: 'error',
									title: handleErrors(error, ''),
									timer: 6000,
								})
							})
					}
				})
		},

		calculatePercent(data) {
			let percent = Math.ceil(((parseInt(data.finished) + parseInt(data.skipped)) / parseInt(data.total)) * 100)
			return percent
		},

		checkDataWorkers() {},

		getWebsiteStatusBadge(code) {
			const statusClasses = {
				success: [HTTP_STATUS.OK, HTTP_STATUS.CREATED, HTTP_STATUS.ACCEPTED],
				info: [HTTP_STATUS.MOVED_PERMANENTLY, HTTP_STATUS.FOUND, HTTP_STATUS.TEMPORARY_REDIRECT, HTTP_STATUS.PERMANENT_REDIRECT],
				warning: [HTTP_STATUS.BAD_REQUEST, HTTP_STATUS.UNAUTHORIZED, HTTP_STATUS.FORBIDDEN, HTTP_STATUS.NOT_FOUND, HTTP_STATUS.TOO_MANY_REQUESTS],
				danger: [
					HTTP_STATUS.NO_RESPONSE, HTTP_STATUS.INTERNAL_SERVER_ERROR, HTTP_STATUS.BAD_GATEWAY, HTTP_STATUS.SERVICE_UNAVAILABLE, HTTP_STATUS.GATEWAY_TIMEOUT,
					HTTP_STATUS.CF_UNKNOWN_ERROR, HTTP_STATUS.CF_WEB_SERVER_DOWN, HTTP_STATUS.CF_CONNECTION_TIMEOUT,
					HTTP_STATUS.CF_ORIGIN_UNREACHABLE, HTTP_STATUS.CF_TIMEOUT, HTTP_STATUS.CF_SSL_HANDSHAKE_FAILED,
					HTTP_STATUS.CF_INVALID_SSL, HTTP_STATUS.CF_RAILGUN_ERROR, HTTP_STATUS.CF_ORIGIN_DNS_ERROR
				]
			}

			if (code === null || code === undefined) return { label: '', class: '' }
			
			const status = STATUS_CODES.find(s => s.value === code)
			const colorClass = Object.entries(statusClasses).find(([, codes]) => codes.includes(code))?.[0]

			return {
				label: status ? `${code} (${status.label})` : code,
				class: colorClass ? `bg-${colorClass}` : 'bg-secondary'
			}
		},

		getFingerprintBadgeClass(fieldName) {
			const badgeClasses = {
				provider_fingerprints: 'bg-primary',
				technology_fingerprints: 'bg-warning text-dark',
				hosting_fingerprints: 'bg-info',
				cms_fingerprints: 'bg-danger',
				product_fingerprints: 'bg-success',
			}
			return badgeClasses[fieldName] || 'bg-secondary'
		},

		formatNumberLocale(value) {
			return formatNumberLocaleUtil(value)
		},
	},
	filters: {
		percent: function(value) {
			if (!value) return ''
			value = value / 10
			return value + ' %'
		},
	},
}
</script>

<style scoped>
@keyframes fb-missing-pulse {
	0% {
		transform: scale(1);
		opacity: 0.5;
	}
	50% {
		transform: scale(1.12);
		opacity: 1;
	}
	100% {
		transform: scale(1);
		opacity: 0.5;
	}
}

.fb-missing-freshbooks {
	display: inline-block;
	animation: fb-missing-pulse 1.6s ease-in-out infinite;
}
</style>
